import { FlexWorkerItem } from './flex-workers.types';

const getFlexWorkersTableData = (data: FlexWorkerItem[]) => {
  return data.map((item) => ({
    id: item.id,
    userProfile: {
      firstName: item.firstName,
      infix: item.infix,
      lastName: item.lastName,
      imageUrl: item.imageUrl,
    },
    email: item.email,
    name: item.name,
    phone: item.phone,
    rating: item.rating,
    deleteAction: null,
  }));
};

export { getFlexWorkersTableData };
